// UpsellCTA — wraps any "Buy / Get $1 access" button so it auto-hides for users
// who are already paid (or admin). For unpaid users it renders a button that
// goes to /signup; if they're signed in but unpaid, it points to /pricing.

import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function UpsellCTA({
    children,
    className = "",
    label = "Open the free viewer",
    iconRight = true,
    paidLabel = "Open the editor",
    paidHref = "/app",
    "data-testid": testId,
}) {
    const { user } = useAuth();
    const isPaid = !!user && (user.is_paid || user.role === "admin");

    // Paid → switch the CTA into a "go to editor" button so the page stays useful.
    if (isPaid) {
        return (
            <Link
                to={paidHref}
                className={className}
                data-testid={testId || "cta-paid"}
            >
                {paidLabel} {iconRight && <ArrowRight size={16} className="inline ml-1" />}
            </Link>
        );
    }

    // Unpaid users → /app (free viewer mode). The pricing page is one click away.
    const href = "/app";

    return (
        <Link to={href} className={className} data-testid={testId || "cta-buy"}>
            {children || label} {iconRight && <ArrowRight size={16} className="inline ml-1" />}
        </Link>
    );
}
